import { useState } from 'react';
import { api } from '../lib/api';

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get<{ url: string }>('/auth/login');
      window.location.href = response.data.url;
    } catch (err) {
      setError('Failed to initiate login. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/Background.jpg')" }}>
      <div className="max-w-md w-full space-y-8 p-10 bg-gray-800 rounded-xl shadow-2xl">
        <div className="text-center">
          <img src="/EVEPPS_Logo.png" alt="EVE PPS" className="mx-auto mb-4 rounded-lg shadow-lg" />
          <h1 className="text-2xl font-bold text-white mb-2">Production Planning System</h1>
          <p className="text-gray-400 text-sm">
            Sign in with your EVE Online account
          </p>
        </div>

        <div className="mt-8 space-y-6">
          {error && (
            <div className="bg-red-500 bg-opacity-10 border border-red-500 text-red-400 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            {loading ? (
              <span className="flex items-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Connecting...
              </span>
            ) : (
              <span className="flex items-center">
                <svg
                  className="mr-2 h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clipRule="evenodd"
                  />
                </svg>
                Sign in with EVE Online
              </span>
            )}
          </button>

          <div className="text-center text-sm text-gray-400">
            <p>
              By signing in, you'll be redirected to EVE Online's secure login
              page.
            </p>
          </div>
        </div>

        <div className="mt-6 border-t border-gray-700 pt-6">
          <div className="text-xs text-gray-500 text-center space-y-2">
            <p>
              EVE PPS uses EVE Online's official SSO for secure authentication.
            </p>
            <p>
              We only access publicly available character information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
